import type { TitleHeaderProps } from './TitleHeader.types'

function TitleHeader(params: TitleHeaderProps) {
  const { title, buttonText, onButtonClick } = params

  return (
    <div className="flex justify-between items-center mb-4">
      <h1 className="text-2xl font-semibold">{title}</h1>
      <button
        className="px-4 py-2 bg-blue-600 text-white rounded-lg disabled:opacity-60 hover:bg-blue-700 transition"
        type="button"
        aria-label={buttonText}
        title={buttonText}
        disabled={!onButtonClick}
        onClick={onButtonClick}
      >
        <span className="text-sm">{buttonText}</span>
      </button>
    </div>
  )
}

export default TitleHeader
